import PropTypes from "prop-types";
import {
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Legend,
  Bar,
} from "recharts";
import getRandomColor from "../../utils/randomColors";
import CustomizedAxisTick from "./customTick";

const MyStackedBar = ({ data, width, yunit }) => {
  const keys = Object.keys(data[0]).filter((key) => key !== "name");

  return (
    <ResponsiveContainer width={width} height="100%">
      <BarChart
        width={500}
        height={300}
        data={data}
        margin={{
          top: 20,
          right: 20,
          left: 10,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="name"
          interval={0}
          padding={{ left: 15, right: 15 }}
          tick={<CustomizedAxisTick />}
        />
        <YAxis allowDecimals={false} unit={yunit} domain={["auto", "auto"]} />
        <Tooltip />
        <Legend />
        {keys.map((key) => (
          <Bar key={key} dataKey={key} stackId="a" fill={getRandomColor(key)} />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};

MyStackedBar.defaultProps = {
  data: [],
  width: 300,
  yunit: "",
};
MyStackedBar.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  width: PropTypes.number,
  yunit: PropTypes.string,
};

export default MyStackedBar;
